__turbopack_context__.v({
  "hasMinHeight": "dL_n3W_hasMinHeight",
  "placeholder": "dL_n3W_placeholder",
});
